function formatar(valor) {
  const digitos = (valor || '').replace(/\D/g, '').slice(0, 8);

  if (digitos.length > 4) return digitos.slice(0, 2) + '/' + digitos.slice(2, 4) + '/' + digitos.slice(4);
  if (digitos.length > 2) return digitos.slice(0, 2) + '/' + digitos.slice(2);
  return digitos;
}

function contarDigitos(texto) {
  return (texto.match(/\d/g) || []).length;
}

function posicaoAposDigitos(texto, quantidade) {
  if (quantidade <= 0) return 0;

  let contados = 0;

  for (let i = 0; i < texto.length; i++) {
    if (/\d/.test(texto[i])) contados++;
    if (contados === quantidade) return i + 1;
  }

  return texto.length;
}

function ligar(campo) {
  if (!campo || campo.dataset.mascaraData === '1') return;

  campo.dataset.mascaraData = '1';
  campo.setAttribute('maxlength', 10);
  campo.setAttribute('inputmode', 'numeric');

  let ajustando = false;

  campo.addEventListener('input', () => {
    if (ajustando) return;

    const posicao = campo.selectionStart;
    const digitosAntes = contarDigitos(campo.value.slice(0, posicao));
    const texto = formatar(campo.value);

    if (campo.value === texto) return;

    ajustando = true;
    campo.value = texto;

    const nova = posicaoAposDigitos(texto, digitosAntes);
    campo.setSelectionRange(nova, nova);

    campo.dispatchEvent(new Event('input'));
    ajustando = false;
  });
}

export default function aplicarMascaraData(id, tentativas = 10) {
  const raiz = document.getElementById(id);
  const campo = raiz ? (raiz.tagName === 'INPUT' ? raiz : raiz.querySelector('input')) : null;

  if (campo) {
    ligar(campo);
    return;
  }

  if (tentativas > 0) setTimeout(() => aplicarMascaraData(id, tentativas - 1), 120);
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/conciliacao-projeto/mascara-data.js